document.querySelectorAll('[data-team-page]').forEach((page) => {
  const filters = Array.from(page.querySelectorAll('[data-team-filter]'));
  const members = Array.from(page.querySelectorAll('[data-team-member]'));
  const membersSection = page.querySelector('[data-team-members]');

  if (!filters.length || !members.length || !membersSection) {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      const target = filter.dataset.teamFilter || 'all';

      filters.forEach((item) => {
        const isActive = item === filter;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      members.forEach((member) => {
        const terms = (member.dataset.teamTerms || '').split(' ').filter(Boolean);
        const isVisible = target === 'all' || terms.includes(target);
        member.hidden = !isVisible;
      });

      membersSection.scrollIntoView({
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  });
});
